import React from 'react'

import { StyledCapsule } from './Capsule.styles'

export interface CapsuleProps {
  active: boolean
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  children: React.ReactNode
  className?: string
}

export const Capsule: React.FC<CapsuleProps> = ({
  active,
  onClick,
  children,
  className,
}) => {
  return (
    <StyledCapsule active={active} onClick={onClick} className={className}>
      {children}
    </StyledCapsule>
  )
}

Capsule.displayName = 'Capsule'
